<template>
  <div>
    <!-- 筛选 -->
    <el-card style="margin-bottom:10px"
             shadow="never">
      <div style="display:flex">
        <!-- 只选择目的地 -->
        <select-dest :cbPath="false"
                     @selectDest="selectDest"
                     placeholder="请选择目的地城市"
                     :selectInputWidth="150"></select-dest>
        <!-- 选择所在目的地 region区 -->
        <el-select size="mini"
                   v-model="region"
                   filterable
                   @change="selectArea"
                   placeholder="请选择位置">
          <el-option v-for="item in regionList"
                     :key="item.value"
                     :label="item.loc_name"
                     :value="item.loc_id"></el-option>
        </el-select>
        <!-- 酒店/民宿 类型 -->
        <el-select v-model="type"
                   size="mini"
                   style="margin-left:10px;width:100px"
                   @change="renewResidence"
                   placeholder="请选类型">
          <el-option v-for="item in typeList"
                     :key="item.value"
                     :label="item.lable"
                     :value="item.value">
          </el-option>
        </el-select>
        <!-- 搜索 -->
        <el-input size="mini"
                  style="width:20%;margin-left:20px"
                  placeholder="请输入搜索内容"
                  v-model="keyword"
                  clearable>
          <el-button slot="append"
                     @click="searchButton"
                     icon="el-icon-search"></el-button>
        </el-input>
        <!-- 新建 -->
        <div style="margin-left:auto">
          <el-button size="mini"
                     @click="addResidence"
                     type="primary">新建酒店/住宿</el-button>
        </div>

      </div>
    </el-card>
    <!-- 列表 -->
    <el-card shadow="never">
      <el-table :data="residenceData"
                style="width: 100%">
        <el-table-column label="">
          <template slot-scope="image">

            <el-image fit="fill"
                      style="width: 200px; height: 100px"
                      :preview-src-list="[]"
                      :src="image.row.residence_cover"></el-image>

          </template>
        </el-table-column>
        <!-- 名字、信息、定位 -->
        <el-table-column label=""
                         width="180">
          <template slot-scope="info">
            <div>{{info.row.residence_name}}</div>
            <div>位置</div>
          </template>
        </el-table-column>
        <el-table-column prop="name"
                         label=""
                         width="180">
          <template slot-scope="type">
            <el-tag size="mini"
                    v-if="type.row.residence_type == '1'">酒店</el-tag>
            <el-tag size="mini"
                    v-if="type.row.residence_type == '2'">民宿</el-tag>
            <el-tag size="mini"
                    v-if="type.row.residence_type == '3'">别墅</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="address"
                         label="">
          <template slot-scope="dest">
            {{dest.row.city}} / {{dest.row.region}} </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column prop="address"
                         label="">
          <template slot-scope="opeart">
            <el-button size="mini"
                       type="primary"
                       @click="checkResidence(opeart.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination @current-change="handleCurrentChange_system"
                       :small="true"
                       background
                       layout="prev, pager, next,total"
                       :current-page.sync="pagenum_system"
                       :page-size="pagesize"
                       :total="page_account"></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import DestSelect from '../../components/common/select/SelectDest'
export default {
  name: 'residence-hub-list',
  components: {
    'select-dest': DestSelect,
  },
  data() {
    return {
      region: '',
      city: '',
      keyword: '',
      type: '',
      regionList: [],
      residenceData: [],
      //
      typeList: [
        {
          lable: '酒店',
          value: 1,
        },
        {
          lable: '民宿',
          value: 2,
        },
        {
          lable: '别墅',
          value: 3,
        },
      ],
      // 分页
      pagenum_system: 1, // 当前页
      pagesize: 10, // 每页容量，自行设定
      page_account: null,
    }
  },
  mounted() {
    this.getResidenceList()
  },
  methods: {
    handleCurrentChange_system(page_num) {
      this.pagenum_system = page_num
      this.getResidenceList()
    },
    checkResidence(item) {
      const newpage = this.$router.resolve({
        name: 'residence_introduce',
        query: { residence_id: item.id },
      })
      window.open(newpage.href, '_blank')
    },
    getResidenceList() {
      this.$http
        .get(
          `/traver/get_residence_list?p_num=${this.pagenum_system}&p_size=${this.pagesize}&city=${this.city}&region=${this.region}&residence_name=${this.keyword}&type=${this.type}`
        )
        .then((res) => {
          console.log(res)
          if (res.data.errno == '0') {
            this.residenceData = res.data.data
            this.page_account = res.data.total
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    selectDest(value) {
      // console.log(value)
      this.city = value
      // 发送请求获得分区，发给分区选择器
      this.$http.post('/get_dest', { pid: value }).then((res) => {
        console.log(res)
        const { data, errno, errmsg } = res.data
        if (errno == '0') {
          this.regionList = data
        }
      })
    },
    selectArea(value) {
      console.log(value)
    },
    renewResidence(value) {},
    searchButton() {
      this.getResidenceList()
    },
    // 创建酒店
    addResidence() {
      //   1.添加一个迹点名
      this.$prompt('请输入创建的住处名称：', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(({ value }) => {
          // console.log(value);
          //  2.创建
          this.$http
            .get(`/traver/add_residence?residence_name=${value}`)
            .then((res) => {
              // 3.跳转到check 迹点叶敏啊
              // console.log(res);
              if (res.data.errno == 0) {
                this.$router.push(
                  `/residence_introduce?residence_id=${res.data.id}`
                )
              } else {
                this.$message({
                  type: 'info',
                  message: res.data.errmsg,
                })
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消创建',
          })
        })
    },
  },
}
</script>

<style>
</style>